import { render, staticRenderFns } from "./TurningOffReasons.vue?vue&type=template&id=7f361a20"
import script from "./TurningOffReasons.vue?vue&type=script&lang=ts"
export * from "./TurningOffReasons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports